/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class UniversalTrackerGroupApi extends BaseApi {
  endPoint: string = '/api/admin/universal-tracker-groups';
}
